import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  optionImage: {
    position: "relative",
    border: "1px solid",
    borderColor: theme.palette.events.grayShade1,
    borderRadius: "5px",
    width: "42px",
    minWidth: "42px",
    height: "32px",
    marginRight: "10px",
    objectFit: "cover",
  },
  privateEventOption: {
    marginLeft: "10px",
    color: theme.palette.events.whiteTertiary,
    fontWeight: 500,
    fontSize: "12px",
    width: "60px",
    padding: "1px 10px",
    borderRadius: "100px",
    gap: "10px",
    background: theme.palette.events.blue,
    height: "20px",
    lineHeight: "16.39px",
  },
}));
